// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#countdown[data-v-4d91e003]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;height:20px;padding:0 10px;border-radius:11px;border:1px solid #141c20;background-color:#f8fafb}#countdown span[data-v-4d91e003]{font-size:12px;color:#141c20;margin-left:4px;min-width:36px;text-align:right;line-height:1.25}", ""]);
// Exports
module.exports = exports;
